import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const verifyEmail = createAsyncThunk(
  "signup/verifyEmail",
  async (email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invite/verify-email`,
        email,
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message)
    }
  },
);

// Action to verify OTP
export const verifyOTP = createAsyncThunk(
  "signup/verifyOTP",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invite/verify-otp`,
        data,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "OTP verification failed" },
      );
    }
  },
);

// Existing signup action (for reference)
export const signUpData = createAsyncThunk(
  "signup/signUpData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invite/public-signup`,
        data,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Signup failed" },
      );
    }
  },
);

// Redux slice for signup
const signupSlice = createSlice({
  name: "signup",
  initialState: {
    loading: false,
    error: null,
    emailVerified: false,
    otpVerified: false,
    signupSuccess: false,
  },
  reducers: {
    resetSignupState: (state) => {
      state.loading = false;
      state.error = null;
      state.emailVerified = false;
      state.otpVerified = false;
      state.signupSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // Verify Email
    builder
      .addCase(verifyEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.emailVerified = action.payload.status === "success";
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });

    // Verify OTP
    builder
      .addCase(verifyOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.otpVerified = action.payload.status === "success";
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });

    // Signup
    builder
      .addCase(signUpData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signUpData.fulfilled, (state, action) => {
        state.loading = false;
        state.signupSuccess = action.payload.status === "success";
      })
      .addCase(signUpData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const { resetSignupState } = signupSlice.actions;
export default signupSlice.reducer;
